import { useEffect, useState } from "react";
import { getMlRunFileText } from "../api/ml";
import { parseCsv } from "../utils/csv";

export function usePredictions(runId) {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(Boolean(runId));
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      if (!runId) return;
      setLoading(true);
      setError(null);
      try {
        let data;
        try {
          const txt = await getMlRunFileText(runId, "predictions.json");
          data = JSON.parse(txt);
        } catch {
          const txt = await getMlRunFileText(runId, "predictions.csv");
          data = parseCsv(txt);
        }
        if (!cancelled) {
          setRows(Array.isArray(data) ? data : []);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e);
          setRows(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [runId]);

  // Quick summary
  let total = 0, passCount = 0, failCount = 0;
  if (Array.isArray(rows)) {
    total = rows.length;
    failCount = rows.filter(r => Number(r.pred_label) === 0).length; // FAIL=0
    passCount = total - failCount;
  }

  return { rows, loading, error, total, passCount, failCount };
}
